// extracted by mini-css-extract-plugin
module.exports = {"primary":"charts_primary__VOaYa"};